module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "frontmatter-rw Acknowledgements-rw Preface-rw exclude-auto-rw page-open-right-rw",
    attrs: {
      "epub:type": "frontmatter preface",
      "id": "Acknowledgements1"
    }
  }, [_c('div', {
    staticClass: "title-block-rw",
    attrs: {
      "id": "title-block5"
    }
  }, [_c('h1', {
    attrs: {
      "id": "h16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/TOC"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p26"
    }
  }, [_vm._v("Hometown Players started as a trilogy. Three books about three loving, sometimes wild sisters and their hockey hunks that I wrote “for fun.” My husband was working overnights and I was bored and trying to save money so I jumped back into my childhood hobby (writing) to avoid boredom and going out and spending money. And here we are, two and a half years and six Hometown books later, and I’m stunned, thrilled and so damn grateful.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p27"
    }
  }, [_vm._v("Absolutely none of this would have happened without my agent Kimberly Brower. Thank you for taking a chance on me, for all your amazing hard work and for talking me off all the ledges.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p28"
    }
  }, [_vm._v("Thank you Leah Hultenschmidt for being a fantastic, enthusiastic and supportive editor. The schedule has been crazy at times throughout this series but your positivity and willingness to talk through anything and everything has made the craziness manageable. Thank you to the rest of the fabulous team at Forever Yours who touched this book and this series in some way. From the cover art to the promotion you guys have been nothing short of amazing.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p29"
    }
  }, [_vm._v("To my husband, Jack, thank you for being my personal cheerleader. I couldn’t do this without your positivity and support. To my family and friends who have been so supportive, I don’t know what I did to deserve you all but I am forever grateful.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p30"
    }
  }, [_vm._v("To the authors who have created such a strong, supportive community and welcomed me into it, thank you. To the bloggers and readers who not only gave this series a chance but embraced it and loved it—I owe you everything. Thank you.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89c26c76","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/s005-Acknowledgements-01.vue
// module id = 75
// module chunks = 0